<script setup lang="ts">
import { computed } from 'vue'

import type { ReportViewType } from '../../models/chart.types'

import { useI18n } from '@/shared/i18n'
import { SegmentedControl, type SelectOption, type UiSize } from '@/shared/ui'

const model = defineModel<ReportViewType>({ required: true })
const props = withDefaults(
  defineProps<{
    views: readonly ReportViewType[]
    chartDisabled?: boolean
    size?: UiSize
  }>(),
  { chartDisabled: false, size: 'sm' },
)
const { t } = useI18n()

const options = computed<SelectOption<ReportViewType>[]>(() =>
  props.views.map((view) => ({
    value: view,
    label: t(`reports.views.${view}`),
    ...(view === 'chart' && props.chartDisabled ? { disabled: true } : {}),
  })),
)
</script>

<template>
  <SegmentedControl
    v-model="model"
    class="view-type-toggle"
    :style="{ '--view-type-toggle-count': String(options.length) }"
    variant="filled"
    :size="props.size"
    :label="t('reports.views.label')"
    :options="options"
  />
</template>
